import * as Int64 from "bs-platform/lib/es6/int64.js";
import * as Caml_format from "bs-platform/lib/es6/caml_format.js";
var unwrap = Int64.to_string;
var wrap = Caml_format.caml_int64_of_string;
export { unwrap, wrap };
/* No side effect */